






import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    name: "DynamicLink"
})
export default class DynamicLink extends Vue {
    @Prop() link!: string | null;
    get isInternal(): boolean {
        if (this.link !== null){
            if (this.link.toLowerCase() == "http"){
                return false
            } else {
                return true
            }
        } else {
            return false
        }
    }
}
